let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lYtN4")).then(() => parcelRequire('ek20L'));